import React from "react";

export const NotificationButtonIcon: React.FC = () => {
  return (
    <svg
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_21_3)">
        <mask
          id="mask0_21_3"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="20"
          y="20"
          width="44"
          height="44"
        >
          <path
            d="M54.5 20H29.5C24.2533 20 20 24.2533 20 29.5V54.5C20 59.7467 24.2533 64 29.5 64H54.5C59.7467 64 64 59.7467 64 54.5V29.5C64 24.2533 59.7467 20 54.5 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_21_3)">
          <g filter="url(#filter1_d_21_3)">
            <path
              d="M54.5 20H29.5C24.2533 20 20 24.2533 20 29.5V54.5C20 59.7467 24.2533 64 29.5 64H54.5C59.7467 64 64 59.7467 64 54.5V29.5C64 24.2533 59.7467 20 54.5 20Z"
              fill="black"
            />
          </g>
          <path
            d="M54.5 20H29.5C24.2533 20 20 24.2533 20 29.5V54.5C20 59.7467 24.2533 64 29.5 64H54.5C59.7467 64 64 59.7467 64 54.5V29.5C64 24.2533 59.7467 20 54.5 20Z"
            fill="white"
            stroke="#979DAB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.6895 42.75C51.6895 42.9505 51.5462 43.3945 51.2598 44.082C50.873 45.013 50.429 45.7936 49.9277 46.4238C49.097 47.4408 48.1016 48.2428 46.9414 48.8301C45.5091 49.5462 43.862 49.9043 42 49.9043C40.138 49.9043 38.4909 49.5462 37.0586 48.8301C35.8841 48.2428 34.8887 47.4408 34.0723 46.4238C33.5853 45.8079 33.1484 45.0273 32.7617 44.082C32.4609 43.3945 32.3105 42.9505 32.3105 42.75C32.3105 42.5495 32.4609 42.1055 32.7617 41.418C33.1484 40.4727 33.5853 39.6921 34.0723 39.0762C34.903 38.0592 35.8913 37.2572 37.0371 36.6699C38.4694 35.9538 40.1237 35.5957 42 35.5957C43.8763 35.5957 45.5234 35.9538 46.9414 36.6699C48.1159 37.2572 49.1113 38.0592 49.9277 39.0762C50.429 39.7064 50.8659 40.487 51.2383 41.418C51.5391 42.1055 51.6895 42.5495 51.6895 42.75ZM50.0996 42.75C49.7415 41.6471 49.276 40.7448 48.7031 40.043C48.0299 39.1836 47.2135 38.5176 46.2539 38.0449C45.0508 37.429 43.6328 37.1211 42 37.1211C40.3672 37.1211 38.9421 37.429 37.7246 38.0449C36.765 38.5319 35.9486 39.1979 35.2754 40.043C34.7025 40.7448 34.237 41.6471 33.8789 42.75C34.237 43.8529 34.7025 44.7552 35.2754 45.457C35.9486 46.3021 36.765 46.9681 37.7246 47.4551C38.9421 48.0566 40.3636 48.3574 41.9893 48.3574C43.6149 48.3574 45.0365 48.0566 46.2539 47.4551C47.2279 46.9681 48.0443 46.3021 48.7031 45.457H48.7246C49.2832 44.7552 49.7415 43.8529 50.0996 42.75ZM44.6211 40.1074C45.3516 40.8236 45.7168 41.6973 45.7168 42.7285C45.7168 43.7598 45.3551 44.637 44.6318 45.3604C43.9085 46.0837 43.0313 46.4453 42 46.4453C40.9687 46.4453 40.0915 46.0837 39.3682 45.3604C38.6449 44.637 38.2832 43.7598 38.2832 42.7285C38.2832 41.6973 38.6449 40.82 39.3682 40.0967C40.0915 39.3734 40.9687 39.0117 42 39.0117C43.0313 39.0117 43.9049 39.3769 44.6211 40.1074ZM43.5469 41.1816C43.1172 40.752 42.6016 40.5371 42 40.5371C41.3984 40.5371 40.8828 40.752 40.4531 41.1816C40.0234 41.6113 39.8086 42.127 39.8086 42.7285C39.8086 43.3301 40.0234 43.8457 40.4531 44.2754C40.8828 44.7051 41.3984 44.9199 42 44.9199C42.6016 44.9199 43.1172 44.7051 43.5469 44.2754C43.9766 43.8457 44.1914 43.3301 44.1914 42.7285C44.1914 42.127 43.9766 41.6113 43.5469 41.1816Z"
            fill="#212B40"
            stroke="#212B40"
            strokeWidth="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_21_3"
          x="0"
          y="0"
          width="84"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_21_3"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_21_3"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_21_3"
          x="16"
          y="18"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_21_3"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_21_3"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
